// extracted by mini-css-extract-plugin
export default {"titleDiv":"PointsDetail_titleDiv__X3Kk0","title0":"PointsDetail_title0__zF6NI","title1":"PointsDetail_title1__x3FXz"};